import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    if (event.type === "keydown" && !["Enter", " "].includes(event.key)) {
      return
    }

    const item = event.currentTarget
    const listItemId = item.dataset.clientRunsListItemId
    if (!listItemId) {
      return
    }

    if (event.type === "keydown") {
      event.preventDefault()
    }

    window.dispatchEvent(new CustomEvent("delivery:client-runs-list-select", {
      detail: { listItemId }
    }))
  }
}
